'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useClpCourse } from '../../../context/clp-course-provider.react-component';
import type { PreviewableLecture } from '@/types/lecture';

/**
 * Parses the course curriculum and returns lectures where isPreviewable is true.
 * Returns display metadata only — no asset data is fetched here.
 * durationInSeconds is derived directly from the lecture curriculum data.
 */
export function usePreviewableLectures() {
  const $ = _c(3);
  const course = useClpCourse();
  let t0;
  bb0: {
    const sections = course.curriculum?.sections;
    if (!sections) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== sections) {
      t1 = sections.flatMap(_temp).filter(_temp2).map(_temp3);
      $[1] = sections;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  return t0;
}
function _temp3(item_0) {
  const lecture = item_0 as {
    id: string;
    title: string;
    durationInSeconds: number;
    images?: {
      height100?: string | null;
    };
  };
  return {
    id: lecture.id,
    title: lecture.title,
    durationInSeconds: Number(lecture.durationInSeconds),
    thumbnail: lecture.images?.height100 ?? null
  };
}
function _temp2(item) {
  return "isPreviewable" in item && item.isPreviewable;
}
function _temp(section) {
  return section.items;
}